import ComicCard from './ComicCard';
import './Gallery.css';

function Gallery({ albums, onSelectAlbum })
{
   return (
      <div className="gallery">
         {albums.map(album =>
            <ComicCard 
               key={album.id}
               album={album} 
               onClick={onSelectAlbum}
            />
         )}
      </div>
   );
}

export default Gallery;